import { DateSelect } from './DateSelect'
import styles from '../../../Disruptions.module.scss'
import { UseFormReturn } from 'react-hook-form'
import { DisruptionFormValues } from '@/pages/Disruptions/types'
import { useState, useEffect } from 'react'
import { format } from 'date-fns'

export const DateSelectContainer = ({ form }: { form: UseFormReturn<DisruptionFormValues> }) => {
    const [from, setFrom] = useState<Date | undefined>(undefined)
    const [fromTime, setFromTime] = useState('')
    const [fromTimeAllDay, setFromTimeAllDay] = useState(false)
    const [to, setTo] = useState<Date | undefined>(undefined)
    const [toTime, setToTime] = useState('')
    const [toTimeAllDay, setToTimeAllDay] = useState(false)

    const start = form.watch('start')
    const end = form.watch('end')

    useEffect(() => {
        // If both start and end are empty, reset all local state values
        if (!start && !end) {
            setFrom(undefined)
            setFromTime('')
            setFromTimeAllDay(false)
            setTo(undefined)
            setToTime('')
            setToTimeAllDay(false)
        }

        // populate data for update form
        if (start) {
            setFrom(new Date(start))
            setFromTime(format(new Date(start), 'HH:mm'))
            setTo(end ? new Date(end) : undefined)
            setToTime(end ? format(new Date(end), 'HH:mm') : '')
        }
    }, [start, end])

    return (
        <>
            <td className={styles.formCell} key={'start'}>
                <DateSelect
                    form={form}
                    label="Start"
                    from={from}
                    fromTimeAllDay={fromTimeAllDay}
                    fromTime={fromTime}
                    to={to}
                    toTimeAllDay={toTimeAllDay}
                    toTime={toTime}
                    setFrom={setFrom}
                    setFromTime={setFromTime}
                    setFromTimeAllDay={setFromTimeAllDay}
                    setTo={setTo}
                    setToTime={setToTime}
                    setToTimeAllDay={setToTimeAllDay}
                />
            </td>

            <td className={styles.formCell} key={'end'}>
                <DateSelect
                    form={form}
                    label="End"
                    from={from}
                    fromTimeAllDay={fromTimeAllDay}
                    fromTime={fromTime}
                    to={to}
                    toTimeAllDay={toTimeAllDay}
                    toTime={toTime}
                    setFrom={setFrom}
                    setFromTime={setFromTime}
                    setFromTimeAllDay={setFromTimeAllDay}
                    setTo={setTo}
                    setToTime={setToTime}
                    setToTimeAllDay={setToTimeAllDay}
                />
            </td>
        </>
    )
}
